module.exports = __webpack_public_path__ + "static/media/fold-angle.30044335.png";